import { Timestamp } from '#/components/timestamp';
import { Button } from '#/components/ui/button';
import { HoverCardContent } from '#/components/ui/hover-card';
import { ScrollArea } from '#/components/ui/scroll-area';
import { ValidatorEventEnum } from '#/constants/pectra/validator-event';
import {
  EthereumStakingValidatorInfo,
  ValidatorEvent as ValidatorEventEvent,
} from '#/data/react-query/queries/order-list';
import useEthereumBeaconscanBlockExplorer from '#/data/useEthereumBeaconscanBlockExplorer';
import { Translation } from 'intl-lib';
import { ExternalLink } from 'lucide-react';
import matchSwitch, { _ } from 'match-switch';
import Link from 'next/link';

interface Props {
  item: EthereumStakingValidatorInfo;
}
export function ValidatorEventHoverCardContent({ item }: Props) {
  const blockExplorer = useEthereumBeaconscanBlockExplorer();
  return (
    <HoverCardContent>
      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-2">
          <h4 className="text-sm font-semibold">Events</h4>
          <ScrollArea className="max-h-48">
            <div className="flex flex-col gap-2">
              {item.event?.map((event, i) => (
                <ValidatorEventItem key={i} event={event} />
              ))}
            </div>
          </ScrollArea>
        </div>
        <div className="flex items-center gap-2">
          <Button type="button" variant="outline" size="sm" asChild>
            <Link
              href={`${blockExplorer?.url}/validator/${
                item.validatorIndex ?? item.pubKey
              }`}
              target="_blank"
              rel="noreferrer"
              prefetch={false}
            >
              <ExternalLink />
              <Translation
                path="global.noun.view_on_button_label"
                params={blockExplorer}
              />
            </Link>
          </Button>
        </div>
      </div>
    </HoverCardContent>
  );
}

type ValidatorEventItemProps = {
  event: ValidatorEventEvent;
};

function ValidatorEventItem({ event }: ValidatorEventItemProps) {
  const badge = matchSwitch(event.event, {
    [ValidatorEventEnum.DEPOSITS]: 'Deposit',
    [ValidatorEventEnum.WITHDRAWALS]: 'Partial Withdrawal',
    [ValidatorEventEnum.CONSOLIDATIONS]: 'Consolidation',
    [_]: event.event,
  });

  return (
    <div className="flex flex-col gap-px">
      <div className="text-sm truncate">{badge}</div>
      <div className="text-xs text-muted-foreground">
        <Timestamp date={event.createTime} toggleable />
      </div>
    </div>
  );
}
